export const ACTIVITY_OFFLINE_CODE = 10003;
export const ACTIVITY_OFFLINE_CODE_MAIN_QUERY = 10033;
export const ACTIVITY_BLOKCED_CODE = 14001;
export const TEAM_IS_FULL_CODE = 10050;
export const INVITE_LIMIT_CODE = 10057;
export const INVITE_INVALID_TARGET_CODE = 10061;
export const DRAW_LIMIT_CODE = 18032; // 单日抽奖次数限制
export const NOT_CREATE_OR_JOIN_TEAM = 10062; // 不可加入战队或创建战队
export const NO_VALID_ORDER_FOR_FREE_CARD = 10063; // 不可使用免单卡
export const NOT_TEAM_LEADER_CODE = 19020; // 非队长用户，不可设置心愿
export const INVALID_CODES = [ACTIVITY_OFFLINE_CODE, ACTIVITY_BLOKCED_CODE, ACTIVITY_OFFLINE_CODE_MAIN_QUERY, TEAM_IS_FULL_CODE, INVITE_LIMIT_CODE, INVITE_INVALID_TARGET_CODE, DRAW_LIMIT_CODE, NOT_CREATE_OR_JOIN_TEAM, NO_VALID_ORDER_FOR_FREE_CARD, NOT_TEAM_LEADER_CODE];
export const USER_INFO_VALID_CODE = 401;
export const USER_INFO_VALID_MSG = "登录信息错误";
export const PLAY_TYPE = /** 组队打Call玩法 */ 27;
export var ShareType;
(function (ShareType) {
    ShareType["WX_CARD"] = "wxCard";
    ShareType["QR_CODE"] = "qrCode";
    ShareType["CALL_LINK"] = "callLink";
    ShareType["H5_LINK"] = "h5Link";
})(ShareType || (ShareType = {}));
export var InviteType;
(function (InviteType) {
    InviteType[InviteType["INVITE_MEMBER"] = 1] = "INVITE_MEMBER";
    InviteType[InviteType["INVITE_CALL"] = 2] = "INVITE_CALL";
    InviteType[InviteType["INVITE_UNLOCK_FREE_CARD"] = 3] = "INVITE_UNLOCK_FREE_CARD";
    InviteType[InviteType["INVITE_BRIGHT_CITY"] = 4] = "INVITE_BRIGHT_CITY";
})(InviteType || (InviteType = {}));
export const USER_DEFAULT_AVATAR = 'https://p0.meituan.net/travelcube/524c1332620f62a704a4d36d7704c8bf8900.png';
export var BenefitType;
(function (BenefitType) {
    BenefitType[BenefitType["POINTS"] = 10] = "POINTS";
})(BenefitType || (BenefitType = {}));
/**
 * 心愿内容枚举
 */
export var WISH_CODE_ENUM;
(function (WISH_CODE_ENUM) {
    /** 看一场璀璨烟花秀 */
    WISH_CODE_ENUM[WISH_CODE_ENUM["FIREWORKS"] = 1] = "FIREWORKS";
    /** 泡一次惬意温泉 */
    WISH_CODE_ENUM[WISH_CODE_ENUM["HOT_SPRING"] = 2] = "HOT_SPRING";
    /** 听一场震撼演唱会 */
    WISH_CODE_ENUM[WISH_CODE_ENUM["CONCERT"] = 3] = "CONCERT";
    /** 举杯庆祝新一年 */
    WISH_CODE_ENUM[WISH_CODE_ENUM["TOAST"] = 4] = "TOAST";
    /** 求一张新年好运签 */
    WISH_CODE_ENUM[WISH_CODE_ENUM["FORTUNE"] = 5] = "FORTUNE";
    /** 倒计时欢呼迎来新一年 */
    WISH_CODE_ENUM[WISH_CODE_ENUM["COUNTDOWN"] = 6] = "COUNTDOWN";
    /** 滑雪跨越新一年 */
    WISH_CODE_ENUM[WISH_CODE_ENUM["SKIING"] = 7] = "SKIING";
    /** 看新年第一次日出 */
    WISH_CODE_ENUM[WISH_CODE_ENUM["SUNRISE"] = 8] = "SUNRISE";
    /** 跟家人一起欢聚 */
    WISH_CODE_ENUM[WISH_CODE_ENUM["FAMILY_REUNION"] = 9] = "FAMILY_REUNION";
    /** 吃一顿超满足美食 */
    WISH_CODE_ENUM[WISH_CODE_ENUM["DELICIOUS_FOOD"] = 10] = "DELICIOUS_FOOD";
})(WISH_CODE_ENUM || (WISH_CODE_ENUM = {}));
